'use strict';

exports.__esModule = true;

var _behaviors;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _actionTypes = require('./actionTypes');

var _mapValues = require('./mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _read = require('./read');

var _read2 = _interopRequireDefault(_read);

var _write = require('./write');

var _write2 = _interopRequireDefault(_write);

var _getValuesFromState = require('./getValuesFromState');

var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);

var _initializeState = require('./initializeState');

var _initializeState2 = _interopRequireDefault(_initializeState);

var _resetState = require('./resetState');

var _resetState2 = _interopRequireDefault(_resetState);

var initialState = {
  _active: undefined,
  _asyncValidating: false,
  _error: undefined,
  _submitting: false,
  _submitFailed: false
};

exports.initialState = initialState;
var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
  var path = _ref.path;
  var index = _ref.index;
  var value = _ref.value;

  var array = _read2['default'](path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  var newValue = { value: value };
  if (index === undefined) {
    arrayCopy.push(newValue);
  } else {
    arrayCopy.splice(index, 0, newValue);
  }
  return _write2['default'](path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.BLUR] = function (state, _ref2) {
  var field = _ref2.field;
  var value = _ref2.value;
  var touch = _ref2.touch;

  // remove _active from state
  var _active = state._active;

  var stateCopy = _objectWithoutProperties(state, ['_active']);

  // eslint-disable-line prefer-const
  return _write2['default'](field, function (previous) {
    var result = _extends({}, previous);
    if (value !== undefined) {
      result.value = value;
    }
    if (touch) {
      result.touched = true;
    }
    return result;
  }, stateCopy);
}, _behaviors[_actionTypes.CHANGE] = function (state, _ref3) {
  var field = _ref3.field;
  var value = _ref3.value;
  var touch = _ref3.touch;

  return _write2['default'](field, function (previous) {
    var _extends9 = _extends({}, previous, { value: value });

    var asyncError = _extends9.asyncError;
    var submitError = _extends9.submitError;

    var result = _objectWithoutProperties(_extends9, ['asyncError', 'submitError']);

    if (touch) {
      result.touched = true;
    }
    return result;
  }, state);
}, _behaviors[_actionTypes.DESTROY] = function () {
  return undefined;
}, _behaviors[_actionTypes.FOCUS] = function (state, _ref4) {
  var field = _ref4.field;

  var stateCopy = _write2['default'](field + '.visited', true, state);
  stateCopy._active = field;
  return stateCopy;
}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref5) {
  var data = _ref5.data;

  return _extends({}, _initializeState2['default'](data), {
    _asyncValidating: false,
    _active: undefined,
    _error: undefined,
    _submitting: false,
    _submitFailed: false
  });
}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref6) {
  var path = _ref6.path;
  var index = _ref6.index;

  var array = _read2['default'](path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  if (index === undefined) {
    arrayCopy.pop();
  } else if (isNaN(index)) {
    delete arrayCopy[index];
  } else {
    arrayCopy.splice(index, 1);
  }
  return _write2['default'](path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.RESET] = function (state) {
  return _extends({}, _resetState2['default'](state), {
    _active: undefined,
    _asyncValidating: false,
    _error: undefined,
    _submitting: false,
    _submitFailed: false
  });
}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state) {
  return _extends({}, state, {
    _asyncValidating: true
  });
}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
  return _extends({}, state, {
    _submitting: true
  });
}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref7) {
  var errors = _ref7.errors;

  return _extends({}, _mapValues2['default'](state, function (value) {
    return value && value.asyncError ? _extends({}, value, { asyncError: undefined }) : value;
  }), _mapValues2['default'](errors, function (error, key) {
    return _extends({}, state[key], {
      asyncError: error
    });
  }), {
    _asyncValidating: false,
    _error: errors && errors._error
  });
}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref8) {
  var errors = _ref8.errors;

  return _extends({}, state, errors ? _mapValues2['default'](errors, function (error, key) {
    return _extends({}, state[key], {
      submitError: error
    });
  }) : {}, {
    _error: errors && errors._error,
    _submitting: false,
    _submitFailed: !!(errors && Object.keys(errors).length)
  });
}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
  return _extends({}, state, {
    _submitFailed: true
  });
}, _behaviors[_actionTypes.TOUCH] = function (state, _ref9) {
  var fields = _ref9.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return _write2['default'](field, function (value) {
      return _extends({}, value, { touched: true });
    }, accumulator);
  }, state));
}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref10) {
  var fields = _ref10.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return _write2['default'](field, function (value) {
      if (value) {
        var touched = value.touched;

        var rest = _objectWithoutProperties(value, ['touched']);

        return rest;
      }
      return value;
    }, accumulator);
  }, state));
}, _behaviors);

var reducer = function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var behavior = behaviors[action.type];
  return behavior ? behavior(state, action) : state;
};

function formReducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _extends7;

  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var form = action.form;
  var key = action.key;

  var rest = _objectWithoutProperties(action, ['form', 'key']);

  // eslint-disable-line no-redeclare
  if (!form) {
    return state;
  }
  if (key) {
    var _extends4, _extends5;

    if (action.type === _actionTypes.DESTROY) {
      var _extends3;

      return _extends({}, state, (_extends3 = {}, _extends3[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
        var _extends2;

        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[stateKey] = state[form][stateKey], _extends2));
      }, {}), _extends3));
    }
    return _extends({}, state, (_extends5 = {}, _extends5[form] = _extends({}, state[form], (_extends4 = {}, _extends4[key] = reducer((state[form] || {})[key], rest), _extends4)), _extends5));
  }
  if (action.type === _actionTypes.DESTROY) {
    return Object.keys(state).reduce(function (accumulator, formName) {
      var _extends6;

      return formName === form ? accumulator : _extends({}, accumulator, (_extends6 = {}, _extends6[formName] = state[formName], _extends6));
    }, {});
  }
  return _extends({}, state, (_extends7 = {}, _extends7[form] = reducer(state[form], rest), _extends7));
}

/**
 * Adds additional functionality to the reducer
 */
function decorate(target) {
  target.plugin = function plugin(reducers) {
    var _this = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var result = _this(state, action);
      return _extends({}, result, _mapValues2['default'](reducers, function (pluginReducer, key) {
        return pluginReducer(result[key] || initialState, action);
      }));
    });
  };

  target.normalize = function normalize(normalizers) {
    var _this2 = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var result = _this2(state, action);
      return _extends({}, result, _mapValues2['default'](normalizers, function (formNormalizers, form) {
        var runNormalize = function runNormalize(previous, currentResult) {
          var previousValues = _getValuesFromState2['default'](_extends({}, initialState, previous));
          var formResult = _extends({}, initialState, currentResult);
          return _extends({}, formResult, _mapValues2['default'](formNormalizers, function (fieldNormalizer, field) {
            return _extends({}, formResult[field], {
              value: fieldNormalizer(formResult[field] ? formResult[field].value : undefined, // value
              previous && previous[field] ? previous[field].value : undefined, // previous value
              _getValuesFromState2['default'](formResult), // all field values
              previousValues) // all previous field values
            });
          }));
        };
        if (action.key) {
          var _extends8;

          return _extends({}, result[form], (_extends8 = {}, _extends8[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends8));
        }
        return runNormalize(state[form], result[form]);
      }));
    });
  };

  return target;
}

exports['default'] = decorate(formReducer);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/reducer.js
// module id = 498
// module chunks = 0